module.exports = __webpack_public_path__ + "img/slack_icon_black.5cca7f68.png";